export const environment = {
    production: false,
    apiUrl: 'https://cdp-worker-api-dev.fpt-international-telecom-company-limited.workers.dev',
    zoneSaaSProviderHostName: 'cf.fptcloudhub.io'
};
